import React from 'react';
import PublicLayout from '../Layout/PublicLayout';
import { useNavigate } from 'react-router-dom';

const Disclaimer = () => {
    const navigate = useNavigate();

    return (
        <PublicLayout onLogin={() => navigate('/login')} onRegister={() => navigate('/register')}>
            <div style={{ paddingTop: '100px', paddingBottom: '100px', maxWidth: '1000px', margin: '0 auto', paddingLeft: '20px', paddingRight: '20px' }}>
                <h1 style={{ fontFamily: 'Orbitron', fontSize: '2.5rem', color: 'var(--primary-color)', marginBottom: '40px' }}>
                    Disclaimer
                </h1>

                <div className="card" style={{ padding: '40px', lineHeight: '1.8', color: 'var(--text-secondary)' }}>
                    <p style={{ marginBottom: '20px' }}>
                        **ZeroPing** is an independent esports tournament platform and is not affiliated with, endorsed by, or sponsored by Krafton, Tencent Games, or the creators of Battlegrounds Mobile India (BGMI).
                    </p>

                    <h3 style={{ color: 'var(--text-primary)', marginTop: '30px', marginBottom: '15px' }}>1. No Gambling Involved</h3>
                    <p style={{ marginBottom: '20px' }}>
                        ZeroPing is strictly a **skill-based** platform. We do not host, support, or promote gambling, betting, or wagering of any kind. All winnings are based solely on the skill and performance of the players in the respective tournaments.
                    </p>

                    <h3 style={{ color: 'var(--text-primary)', marginTop: '30px', marginBottom: '15px' }}>2. Financial Risk</h3>
                    <p style={{ marginBottom: '20px' }}>
                        Participation in paid tournaments involves a financial entry fee. Users are advised to play responsibly and only with money they can afford to spend. ZeroPing is not responsible for any financial losses incurred while using the platform.
                    </p>

                    <h3 style={{ color: 'var(--text-primary)', marginTop: '30px', marginBottom: '15px' }}>3. Restricted States</h3>
                    <p style={{ marginBottom: '20px' }}>
                        In accordance with Indian laws, users residing in states where paid online gaming is prohibited (such as Assam, Odisha, Nagaland, Sikkim, Telangana, and Andhra Pradesh) are **strictly prohibited** from participating in paid tournaments on ZeroPing.
                    </p>

                    <h3 style={{ color: 'var(--text-primary)', marginTop: '30px', marginBottom: '15px' }}>4. Fair Play</h3>
                    <p style={{ marginBottom: '20px' }}>
                        We maintain a strict zero-tolerance policy against hacking, cheating, or any form of unfair play. Accounts found violating these rules will be permanently banned and any winnings will be forfeited.
                    </p>
                </div>
            </div>
        </PublicLayout>
    );
};

export default Disclaimer;
